import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Send = createReactComponent("Send", ["svg", defaultAttributes, [["line", {
  x1: "22",
  y1: "2",
  x2: "11",
  y2: "13",
  key: "1fvfb0"
}], ["polygon", {
  points: "22 2 15 22 11 13 2 9 22 2",
  key: "1ews36"
}]]]);
export default Send;